'use strict';

// Generated by build/legacy/generate-page-loaders.js.
// Edit build/legacy/module-maps/pages.registry.js instead.
const api = {};

const modules = {
	'accountingflagspage': {
		chunkName: 'legacy-pages-accountingflagspage-9919fdac',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-accountingflagspage-9919fdac" */ '@app/pages/accountingFlags/accountingFlags.js');
		}
	},
	'accountingpage': {
		chunkName: 'legacy-pages-accountingpage-ade70022',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-accountingpage-ade70022" */ '@app/pages/accounting/accounting.js');
		}
	},
	'accountingtodopage': {
		chunkName: 'legacy-pages-accountingtodopage-b5034130',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-accountingtodopage-b5034130" */ '@app/pages/accountingToDo/accountingToDo.js');
		}
	},
	'accountingtypespage': {
		chunkName: 'legacy-pages-accountingtypespage-ffc37e6b',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-accountingtypespage-ffc37e6b" */ '@app/pages/accountingTypes/accountingTypes.js');
		}
	},
	'accountsreceivablepage': {
		chunkName: 'legacy-pages-accountsreceivablepage-b0032d63',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-accountsreceivablepage-b0032d63" */ '@app/pages/accountsReceivable/accountsReceivable.js');
		}
	},
	'addareacalendarpage': {
		chunkName: 'legacy-pages-addareacalendarpage-67406e10',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-addareacalendarpage-67406e10" */ '@app/pages/addAreaCalendar/addAreaCalendar.js');
		}
	},
	'additionalengravingoptionspage': {
		chunkName: 'legacy-pages-additionalengravingoptionspage-d5a05bde',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-additionalengravingoptionspage-d5a05bde" */ '@app/pages/additionalEngravingOptions/additionalEngravingOptions.js');
		}
	},
	'admintoolspage': {
		chunkName: 'legacy-pages-admintoolspage-4af8af75',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-admintoolspage-4af8af75" */ '@app/pages/adminTools/adminTools.js');
		}
	},
	'admintoolsreactpage': {
		chunkName: 'legacy-pages-admintoolsreactpage-767758a4',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-admintoolsreactpage-767758a4" */ '@app/pages/adminToolsReact/adminToolsReact.js');
		}
	},
	'aftercareonlinebookingspage': {
		chunkName: 'legacy-pages-aftercareonlinebookingspage-a4f1d5d3',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-aftercareonlinebookingspage-a4f1d5d3" */ '@app/pages/aftercareOnlineBookings/aftercareOnlineBookings.js');
		}
	},
	'ailmentspage': {
		chunkName: 'legacy-pages-ailmentspage-ff53ccfc',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-ailmentspage-ff53ccfc" */ '@app/pages/ailments/ailments.js');
		}
	},
	'appointmenthospicereportpage': {
		chunkName: 'legacy-pages-appointmenthospicereportpage-ba6debc9',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-appointmenthospicereportpage-ba6debc9" */ '@app/pages/appointmentHospiceReport/appointmentHospiceReport.js');
		}
	},
	'appointmentinfo': {
		chunkName: 'legacy-pages-appointmentinfo-fd55ec9b',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-appointmentinfo-fd55ec9b" */ '@app/pages/appointmentInfo/appointmentInfo.js');
		}
	},
	'appointmentnotes': {
		chunkName: 'legacy-pages-appointmentnotes-5a45342f',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-appointmentnotes-5a45342f" */ '@app/pages/appointment/appointmentNotes.js');
		}
	},
	'appointmentnoticereportpage': {
		chunkName: 'legacy-pages-appointmentnoticereportpage-0a563ca6',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-appointmentnoticereportpage-0a563ca6" */ '@app/pages/appointmentNoticeReport/appointmentNoticeReport.js');
		}
	},
	'appointmentobservabilityutils': {
		chunkName: 'legacy-pages-appointmentobservabilityutils-4cc439c1',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-appointmentobservabilityutils-4cc439c1" */ '@app/pages/appointment/appointmentObservabilityUtils.js');
		}
	},
	'appointmentoverviewreportpage': {
		chunkName: 'legacy-pages-appointmentoverviewreportpage-7184c5e2',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-appointmentoverviewreportpage-7184c5e2" */ '@app/pages/appointmentOverviewReport/appointmentOverviewReport.js');
		}
	},
	'appointmentpage': {
		chunkName: 'legacy-pages-appointmentpage-920ce663',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-appointmentpage-920ce663" */ '@app/pages/appointment/appointment.js');
		}
	},
	'appointmentpaypaldialogpage': {
		chunkName: 'legacy-pages-appointmentpaypaldialogpage-94c62a25',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-appointmentpaypaldialogpage-94c62a25" */ '@app/pages/appointmentPayPalDialog/appointmentPayPalDialog.js');
		}
	},
	'appointmentpricechangesreportpage': {
		chunkName: 'legacy-pages-appointmentpricechangesreportpage-1d987f90',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-appointmentpricechangesreportpage-1d987f90" */ '@app/pages/appointmentPriceChangesReport/appointmentPriceChangesReport.js');
		}
	},
	'appointmentreportpage': {
		chunkName: 'legacy-pages-appointmentreportpage-8bf4845b',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-appointmentreportpage-8bf4845b" */ '@app/pages/appointmentReport/appointmentReport.js');
		}
	},
	'appointmentspage': {
		chunkName: 'legacy-pages-appointmentspage-290ac442',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-appointmentspage-290ac442" */ '@app/pages/appointments/appointments.js');
		}
	},
	'appointmentsummaryreportpage': {
		chunkName: 'legacy-pages-appointmentsummaryreportpage-6b3fe791',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-appointmentsummaryreportpage-6b3fe791" */ '@app/pages/appointmentReport/appointmentReport.js');
		}
	},
	'appointmenttemplates': {
		chunkName: 'legacy-pages-appointmenttemplates-957b06d5',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-appointmenttemplates-957b06d5" */ '@app/pages/appointment/appointmentTemplates.js');
		}
	},
	'appointmenttypeflagspage': {
		chunkName: 'legacy-pages-appointmenttypeflagspage-04584501',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-appointmenttypeflagspage-04584501" */ '@app/pages/appointmentTypeFlags/appointmentTypeFlags.js');
		}
	},
	'appointmenttypespage': {
		chunkName: 'legacy-pages-appointmenttypespage-5dbb8373',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-appointmenttypespage-5dbb8373" */ '@app/pages/appointmentTypes/appointmentTypes.js');
		}
	},
	'areafamilydiscountpage': {
		chunkName: 'legacy-pages-areafamilydiscountpage-7f3d6b3b',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-areafamilydiscountpage-7f3d6b3b" */ '@app/pages/areaFamilyDiscounts/areaFamilyDiscount.js');
		}
	},
	'areapage': {
		chunkName: 'legacy-pages-areapage-4bca355c',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-areapage-4bca355c" */ '@app/pages/area/area.js');
		}
	},
	'areapopuppage': {
		chunkName: 'legacy-pages-areapopuppage-4450bc7b',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-areapopuppage-4450bc7b" */ '@app/pages/areapopup/areapopup.js');
		}
	},
	'areapricingreportpage': {
		chunkName: 'legacy-pages-areapricingreportpage-615467ec',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-areapricingreportpage-615467ec" */ '@app/pages/areaPricingReport/areaPricingReport.js');
		}
	},
	'areaspage': {
		chunkName: 'legacy-pages-areaspage-dedac700',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-areaspage-dedac700" */ '@app/pages/areas/areas.js');
		}
	},
	'areazippage': {
		chunkName: 'legacy-pages-areazippage-7c945aa0',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-areazippage-7c945aa0" */ '@app/pages/areaZip/areaZip.js');
		}
	},
	'ashesinquiriespage': {
		chunkName: 'legacy-pages-ashesinquiriespage-0f388cde',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-ashesinquiriespage-0f388cde" */ '@app/pages/ashesInquiries/ashesInquiries.js');
		}
	},
	'authopenercallback': {
		chunkName: 'legacy-pages-authopenercallback-7e2d9abe',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-authopenercallback-7e2d9abe" */ '@app/pages/authOpenerCallback/authOpenerCallback.js');
		}
	},
	'authorizecreditspage': {
		chunkName: 'legacy-pages-authorizecreditspage-d73c5e65',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-authorizecreditspage-d73c5e65" */ '@app/pages/authorizeCredits/authorizeCredits.js');
		}
	},
	'bandialog': {
		chunkName: 'legacy-pages-bandialog-371fdc2c',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-bandialog-371fdc2c" */ '@app/pages/banDialog/banDialog.js');
		}
	},
	'bankaccountspage': {
		chunkName: 'legacy-pages-bankaccountspage-c955f8ce',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-bankaccountspage-c955f8ce" */ '@app/pages/bankAccounts/bankAccounts.js');
		}
	},
	'bankspage': {
		chunkName: 'legacy-pages-bankspage-2597821c',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-bankspage-2597821c" */ '@app/pages/banks/banks.js');
		}
	},
	'batchpage': {
		chunkName: 'legacy-pages-batchpage-4bf1a8b0',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-batchpage-4bf1a8b0" */ '@app/pages/batch/batch.js');
		}
	},
	'blogcategoriespage': {
		chunkName: 'legacy-pages-blogcategoriespage-ce503f48',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-blogcategoriespage-ce503f48" */ '@app/pages/blogCategories/blogCategories.js');
		}
	},
	'blogpostpage': {
		chunkName: 'legacy-pages-blogpostpage-a36664e9',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-blogpostpage-a36664e9" */ '@app/pages/blogPost/blogPost.js');
		}
	},
	'blogpostspage': {
		chunkName: 'legacy-pages-blogpostspage-b4a176b8',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-blogpostspage-b4a176b8" */ '@app/pages/blogPosts/blogPosts.js');
		}
	},
	'breedspage': {
		chunkName: 'legacy-pages-breedspage-32d3f945',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-breedspage-32d3f945" */ '@app/pages/breeds/breeds.js');
		}
	},
	'callcenterappointmentreportpage': {
		chunkName: 'legacy-pages-callcenterappointmentreportpage-11d0d8b8',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-callcenterappointmentreportpage-11d0d8b8" */ '@app/pages/callCenterAppointmentReports/callCenterAppointmentReport.js');
		}
	},
	'callnoteslistpage': {
		chunkName: 'legacy-pages-callnoteslistpage-1173ab18',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-callnoteslistpage-1173ab18" */ '@app/pages/callNotesList/callNotesList.js');
		}
	},
	'callnotespage': {
		chunkName: 'legacy-pages-callnotespage-62c7691f',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-callnotespage-62c7691f" */ '@app/pages/callNotes/callNotes.js');
		}
	},
	'callresultreportpage': {
		chunkName: 'legacy-pages-callresultreportpage-b2581505',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-callresultreportpage-b2581505" */ '@app/pages/callResultReport/callResultReport.js');
		}
	},
	'cancellationreasonspage': {
		chunkName: 'legacy-pages-cancellationreasonspage-59ee6850',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-cancellationreasonspage-59ee6850" */ '@app/pages/cancellationReasons/cancellationReasons.js');
		}
	},
	'captchadialog': {
		chunkName: 'legacy-pages-captchadialog-c0757456',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-captchadialog-c0757456" */ '@app/pages/captchaDialog/captchaDialog.js');
		}
	},
	'carecreditapiresponsereportpage': {
		chunkName: 'legacy-pages-carecreditapiresponsereportpage-be3aae92',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-carecreditapiresponsereportpage-be3aae92" */ '@app/pages/careCreditApiResponseReport/careCreditApiResponseReport.js');
		}
	},
	'carecredittoprocesspage': {
		chunkName: 'legacy-pages-carecredittoprocesspage-5533d440',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-carecredittoprocesspage-5533d440" */ '@app/pages/careCreditToProcess/careCreditToProcess.js');
		}
	},
	'carrierspage': {
		chunkName: 'legacy-pages-carrierspage-1c3ede11',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-carrierspage-1c3ede11" */ '@app/pages/carriers/carriers.js');
		}
	},
	'certificatetemplatepage': {
		chunkName: 'legacy-pages-certificatetemplatepage-b4cf2621',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-certificatetemplatepage-b4cf2621" */ '@app/pages/certificatetemplate/certificatetemplate.js');
		}
	},
	'certificatetemplatespage': {
		chunkName: 'legacy-pages-certificatetemplatespage-7c5adb24',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-certificatetemplatespage-7c5adb24" */ '@app/pages/certificateTemplates/certificateTemplates.js');
		}
	},
	'chargedialogpage': {
		chunkName: 'legacy-pages-chargedialogpage-7b6664ba',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-chargedialogpage-7b6664ba" */ '@app/pages/chargeDialog/chargeDialog.js');
		}
	},
	'chatentrust': {
		chunkName: 'legacy-pages-chatentrust-b90f5c8d',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-chatentrust-b90f5c8d" */ '@app/pages/chatEntrust/chatEntrust.js');
		}
	},
	'chatfollowupdialog': {
		chunkName: 'legacy-pages-chatfollowupdialog-72cd4e80',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-chatfollowupdialog-72cd4e80" */ '@app/pages/chatFollowUpDialog/chatFollowUpDialog.js');
		}
	},
	'chatspage': {
		chunkName: 'legacy-pages-chatspage-e4995262',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-chatspage-e4995262" */ '@app/pages/chats/chats.js');
		}
	},
	'clientpage': {
		chunkName: 'legacy-pages-clientpage-b553bf6a',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-clientpage-b553bf6a" */ '@app/pages/client/client.js');
		}
	},
	'clientsdialog': {
		chunkName: 'legacy-pages-clientsdialog-5b56b772',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-clientsdialog-5b56b772" */ '@app/pages/clientsDialog/clientsDialog.js');
		}
	},
	'clientspage': {
		chunkName: 'legacy-pages-clientspage-6125f7c4',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-clientspage-6125f7c4" */ '@app/pages/clients/clients.js');
		}
	},
	'clinicreferralreportpage': {
		chunkName: 'legacy-pages-clinicreferralreportpage-ca484372',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-clinicreferralreportpage-ca484372" */ '@app/pages/clinicReferralReport/clinicReferralReport.js');
		}
	},
	'codemirrordialog': {
		chunkName: 'legacy-pages-codemirrordialog-dfac7a55',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-codemirrordialog-dfac7a55" */ '@common/Scripts/pages/codemirrorDialog/codemirrorDialog.js');
		}
	},
	'colorspage': {
		chunkName: 'legacy-pages-colorspage-92fed44d',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-colorspage-92fed44d" */ '@app/pages/colors/colors.js');
		}
	},
	'communalpublicaccessespage': {
		chunkName: 'legacy-pages-communalpublicaccessespage-de123e63',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-communalpublicaccessespage-de123e63" */ '@app/pages/communalPublicAccesses/communalPublicAccesses.js');
		}
	},
	'communalrestingplacespage': {
		chunkName: 'legacy-pages-communalrestingplacespage-d465bade',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-communalrestingplacespage-d465bade" */ '@app/pages/communalRestingPlaces/communalRestingPlaces.js');
		}
	},
	'complaintlistpage': {
		chunkName: 'legacy-pages-complaintlistpage-c205eaa1',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-complaintlistpage-c205eaa1" */ '@app/pages/complaintlist/complaintlist.js');
		}
	},
	'completedappointmentspendingpaymentreportpage': {
		chunkName: 'legacy-pages-completedappointmentspendingpaymentreportpage-ae2e4529',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-completedappointmentspendingpaymentreportpage-ae2e4529" */ '@app/pages/completedAppointmentsPendingPaymentReport/completedAppointmentsPendingPaymentReport.js');
		}
	},
	'confirmationpage': {
		chunkName: 'legacy-pages-confirmationpage-9501c079',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-confirmationpage-9501c079" */ '@app/pages/confirmation/confirmation.js');
		}
	},
	'confirmpage': {
		chunkName: 'legacy-pages-confirmpage-3beed9f8',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-confirmpage-3beed9f8" */ '@app/pages/confirm/confirm.js');
		}
	},
	'consentformpage': {
		chunkName: 'legacy-pages-consentformpage-49540609',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-consentformpage-49540609" */ '@app/pages/consentForm/consentForm.js');
		}
	},
	'consentformspage': {
		chunkName: 'legacy-pages-consentformspage-8a290d42',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-consentformspage-8a290d42" */ '@app/pages/emailTemplates/consentForms.js');
		}
	},
	'controlledsubstancespage': {
		chunkName: 'legacy-pages-controlledsubstancespage-7d380c6c',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-controlledsubstancespage-7d380c6c" */ '@app/pages/controlledSubstances/controlledSubstances.js');
		}
	},
	'corporateentitiespage': {
		chunkName: 'legacy-pages-corporateentitiespage-af45ce02',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-corporateentitiespage-af45ce02" */ '@app/pages/corporateEntities/corporateEntities.js');
		}
	},
	'createdscheduleentriesreportpage': {
		chunkName: 'legacy-pages-createdscheduleentriesreportpage-b8cdfbb3',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-createdscheduleentriesreportpage-b8cdfbb3" */ '@app/pages/createdScheduleEntriesReport/createdScheduleEntriesReport.js');
		}
	},
	'createdvetschedulereasonspage': {
		chunkName: 'legacy-pages-createdvetschedulereasonspage-6e739ad5',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-createdvetschedulereasonspage-6e739ad5" */ '@app/pages/vetScheduleReasons/createdVetScheduleReasons.js');
		}
	},
	'cremationinfopage': {
		chunkName: 'legacy-pages-cremationinfopage-54a6ea26',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-cremationinfopage-54a6ea26" */ '@app/pages/cremationInfo/cremationInfo.js');
		}
	},
	'crematoriespage': {
		chunkName: 'legacy-pages-crematoriespage-0809a160',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-crematoriespage-0809a160" */ '@app/pages/crematories/crematories.js');
		}
	},
	'crematoryassistancereportpage': {
		chunkName: 'legacy-pages-crematoryassistancereportpage-5a2cebc0',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-crematoryassistancereportpage-5a2cebc0" */ '@app/pages/crematoryAssistanceReport/crematoryAssistanceReport.js');
		}
	},
	'crematorycorporationspage': {
		chunkName: 'legacy-pages-crematorycorporationspage-890ab099',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-crematorycorporationspage-890ab099" */ '@app/pages/crematoryCorporations/crematoryCorporations.js');
		}
	},
	'crematorypage': {
		chunkName: 'legacy-pages-crematorypage-330db725',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-crematorypage-330db725" */ '@app/pages/crematory/crematory.js');
		}
	},
	'crematoryservicespage': {
		chunkName: 'legacy-pages-crematoryservicespage-38e1d3c7',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-crematoryservicespage-38e1d3c7" */ '@app/pages/crematoryServices/crematoryServices.js');
		}
	},
	'cropdialog': {
		chunkName: 'legacy-pages-cropdialog-c07b6fdb',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-cropdialog-c07b6fdb" */ '@app/pages/cropDialog/cropDialog.js');
		}
	},
	'customerdialogpage': {
		chunkName: 'legacy-pages-customerdialogpage-df7d8637',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-customerdialogpage-df7d8637" */ '@app/pages/customerDialog/customerDialog.js');
		}
	},
	'dashboardpage': {
		chunkName: 'legacy-pages-dashboardpage-ed0cc080',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-dashboardpage-ed0cc080" */ '@app/pages/dashboard/dashboard.js');
		}
	},
	'dashpage': {
		chunkName: 'legacy-pages-dashpage-34116d0f',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-dashpage-34116d0f" */ '@app/pages/dashPage/dashPage.js');
		}
	},
	'deathcertificatetemplatespage': {
		chunkName: 'legacy-pages-deathcertificatetemplatespage-3b246b28',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-deathcertificatetemplatespage-3b246b28" */ '@app/pages/certificateTemplates/deathCertificatesTemplates.js');
		}
	},
	'deletionreasonpage': {
		chunkName: 'legacy-pages-deletionreasonpage-c4777245',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-deletionreasonpage-c4777245" */ '@app/pages/deletionReason/deletionReason.js');
		}
	},
	'deliveryoptionspage': {
		chunkName: 'legacy-pages-deliveryoptionspage-b0fe4ec7',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-deliveryoptionspage-b0fe4ec7" */ '@app/pages/deliveryOptions/deliveryOptions.js');
		}
	},
	'directoryinquiriespage': {
		chunkName: 'legacy-pages-directoryinquiriespage-0dce8626',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-directoryinquiriespage-0dce8626" */ '@app/pages/directoryInquiries/directoryInquiries.js');
		}
	},
	'directoryinquirypage': {
		chunkName: 'legacy-pages-directoryinquirypage-4e5f0e6a',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-directoryinquirypage-4e5f0e6a" */ '@app/pages/directoryInquiry/directoryInquiry.js');
		}
	},
	'directorylistingpage': {
		chunkName: 'legacy-pages-directorylistingpage-c8447d72',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-directorylistingpage-c8447d72" */ '@app/pages/directoryListing/directoryListing.js');
		}
	},
	'directorylistingspage': {
		chunkName: 'legacy-pages-directorylistingspage-3e602093',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-directorylistingspage-3e602093" */ '@app/pages/directoryListings/directoryListings.js');
		}
	},
	'directorysearchresultspage': {
		chunkName: 'legacy-pages-directorysearchresultspage-f4088b4e',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-directorysearchresultspage-f4088b4e" */ '@app/pages/directorySearchResults/directorySearchResults.js');
		}
	},
	'directoryuserpage': {
		chunkName: 'legacy-pages-directoryuserpage-17a2f1d2',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-directoryuserpage-17a2f1d2" */ '@app/pages/directoryUser/directoryUser.js');
		}
	},
	'directoryuserspage': {
		chunkName: 'legacy-pages-directoryuserspage-2b666958',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-directoryuserspage-2b666958" */ '@app/pages/directoryUsers/directoryUsers.js');
		}
	},
	'directoryzipcodespage': {
		chunkName: 'legacy-pages-directoryzipcodespage-cc2806b2',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-directoryzipcodespage-cc2806b2" */ '@app/pages/directoryZipCodes/directoryZipCodes.js');
		}
	},
	'discountfamilytypepage': {
		chunkName: 'legacy-pages-discountfamilytypepage-1c79feab',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-discountfamilytypepage-1c79feab" */ '@app/pages/discountFamilyType/discountFamilyType.js');
		}
	},
	'discountfamilytypespage': {
		chunkName: 'legacy-pages-discountfamilytypespage-f013c07a',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-discountfamilytypespage-f013c07a" */ '@app/pages/discountFamilyTypes/discountFamilyTypes.js');
		}
	},
	'discountreasonspage': {
		chunkName: 'legacy-pages-discountreasonspage-a2098519',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-discountreasonspage-a2098519" */ '@app/pages/discountReasons/discountReasons.js');
		}
	},
	'distancerecordspage': {
		chunkName: 'legacy-pages-distancerecordspage-c8ed7409',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-distancerecordspage-c8ed7409" */ '@app/pages/distanceRecords/distanceRecords.js');
		}
	},
	'druglocationpage': {
		chunkName: 'legacy-pages-druglocationpage-f90aa37c',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-druglocationpage-f90aa37c" */ '@app/pages/drugLocation/drugLocation.js');
		}
	},
	'druglogchangepage': {
		chunkName: 'legacy-pages-druglogchangepage-889d49a3',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-druglogchangepage-889d49a3" */ '@app/pages/drugLogChanges/drugLogChange.js');
		}
	},
	'druglogpage': {
		chunkName: 'legacy-pages-druglogpage-85ade085',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-druglogpage-85ade085" */ '@app/pages/drugLog/drugLog.js');
		}
	},
	'drugroutepage': {
		chunkName: 'legacy-pages-drugroutepage-99be3b9f',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-drugroutepage-99be3b9f" */ '@app/pages/drugRoute/drugRoute.js');
		}
	},
	'emaildatapage': {
		chunkName: 'legacy-pages-emaildatapage-15d68ef5',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-emaildatapage-15d68ef5" */ '@app/pages/emailData/emailData.js');
		}
	},
	'emailtemplatepage': {
		chunkName: 'legacy-pages-emailtemplatepage-cc442d3b',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-emailtemplatepage-cc442d3b" */ '@app/pages/emailTemplate/emailTemplate.js');
		}
	},
	'emailtemplatesclientcommunicationpage': {
		chunkName: 'legacy-pages-emailtemplatesclientcommunicationpage-864a68ff',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-emailtemplatesclientcommunicationpage-864a68ff" */ '@app/pages/emailTemplates/emailTemplatesClientCommunication.js');
		}
	},
	'emailtemplatescustomtemplatespage': {
		chunkName: 'legacy-pages-emailtemplatescustomtemplatespage-9fec6a34',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-emailtemplatescustomtemplatespage-9fec6a34" */ '@app/pages/emailTemplates/emailTemplatesCustomTemplates.js');
		}
	},
	'emailtemplatesfollowuppage': {
		chunkName: 'legacy-pages-emailtemplatesfollowuppage-e1202c6d',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-emailtemplatesfollowuppage-e1202c6d" */ '@app/pages/emailTemplates/emailTemplatesFollowUp.js');
		}
	},
	'emailtemplatesmemorialspage': {
		chunkName: 'legacy-pages-emailtemplatesmemorialspage-71ec5583',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-emailtemplatesmemorialspage-71ec5583" */ '@app/pages/emailTemplates/emailTemplatesMemorials.js');
		}
	},
	'emailtemplatespage': {
		chunkName: 'legacy-pages-emailtemplatespage-1b512f06',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-emailtemplatespage-1b512f06" */ '@app/pages/emailTemplates/emailTemplates.js');
		}
	},
	'emailtimerestrictionspage': {
		chunkName: 'legacy-pages-emailtimerestrictionspage-24198b26',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-emailtimerestrictionspage-24198b26" */ '@app/pages/emailTimeRestrictions/emailTimeRestrictions.js');
		}
	},
	'employeeinfo': {
		chunkName: 'legacy-pages-employeeinfo-0a18dde5',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-employeeinfo-0a18dde5" */ '@app/pages/employeeInfo/employeeInfo.js');
		}
	},
	'engravingtypespage': {
		chunkName: 'legacy-pages-engravingtypespage-2f60e480',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-engravingtypespage-2f60e480" */ '@app/pages/engravingtypes/engravingtypes.js');
		}
	},
	'eventpage': {
		chunkName: 'legacy-pages-eventpage-43d589e7',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-eventpage-43d589e7" */ '@app/pages/event/event.js');
		}
	},
	'eventtypespage': {
		chunkName: 'legacy-pages-eventtypespage-607235b1',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-eventtypespage-607235b1" */ '@app/pages/eventTypes/eventTypes.js');
		}
	},
	'executivesnapshot': {
		chunkName: 'legacy-pages-executivesnapshot-98b2880d',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-executivesnapshot-98b2880d" */ '@app/pages/executiveSnapshot/executiveSnapshot.js');
		}
	},
	'familytypeflagspage': {
		chunkName: 'legacy-pages-familytypeflagspage-0970a926',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-familytypeflagspage-0970a926" */ '@app/pages/familyTypeFlags/familyTypeFlags.js');
		}
	},
	'faqcategorymanagepage': {
		chunkName: 'legacy-pages-faqcategorymanagepage-4832d7c9',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-faqcategorymanagepage-4832d7c9" */ '@app/pages/faqCategoryManage/faqCategoryManage.js');
		}
	},
	'faqeditpage': {
		chunkName: 'legacy-pages-faqeditpage-539a4fb1',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-faqeditpage-539a4fb1" */ '@app/pages/faqEdit/faqEdit.js');
		}
	},
	'faqmanagepage': {
		chunkName: 'legacy-pages-faqmanagepage-d06d6b5d',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-faqmanagepage-d06d6b5d" */ '@app/pages/faqManage/faqManage.js');
		}
	},
	'feedbackfilterspage': {
		chunkName: 'legacy-pages-feedbackfilterspage-be8c375d',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-feedbackfilterspage-be8c375d" */ '@app/pages/feedbackFilters/feedbackFilters.js');
		}
	},
	'filelinkspage': {
		chunkName: 'legacy-pages-filelinkspage-51e11543',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-filelinkspage-51e11543" */ '@app/pages/fileLinks/fileLinks.js');
		}
	},
	'firstavailableappointmentspage': {
		chunkName: 'legacy-pages-firstavailableappointmentspage-14529224',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-firstavailableappointmentspage-14529224" */ '@app/pages/firstAvailableAppointments/firstAvailableAppointments.js');
		}
	},
	'franchisepaymentspage': {
		chunkName: 'legacy-pages-franchisepaymentspage-8196d84a',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-franchisepaymentspage-8196d84a" */ '@app/pages/franchisePayments/franchisePayments.js');
		}
	},
	'globalsettingsareapage': {
		chunkName: 'legacy-pages-globalsettingsareapage-ffed362a',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-globalsettingsareapage-ffed362a" */ '@app/pages/globalSettings/globalSettingsArea.js');
		}
	},
	'globalsettingshospicedefaultspage': {
		chunkName: 'legacy-pages-globalsettingshospicedefaultspage-44aac68c',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-globalsettingshospicedefaultspage-44aac68c" */ '@app/pages/globalSettings/globalSettingsHospiceDefalts.js');
		}
	},
	'globalsettingsmiscpage': {
		chunkName: 'legacy-pages-globalsettingsmiscpage-a12c0c4b',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-globalsettingsmiscpage-a12c0c4b" */ '@app/pages/globalSettings/globalSettingsMisc.js');
		}
	},
	'globalsettingspage': {
		chunkName: 'legacy-pages-globalsettingspage-e5f1062d',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-globalsettingspage-e5f1062d" */ '@app/pages/globalSettings/globalSettings.js');
		}
	},
	'googleeventspage': {
		chunkName: 'legacy-pages-googleeventspage-bbe5e031',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-googleeventspage-bbe5e031" */ '@app/pages/googleEvents/googleEvents.js');
		}
	},
	'greymuzzleanimalgenderspage': {
		chunkName: 'legacy-pages-greymuzzleanimalgenderspage-09037f94',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-greymuzzleanimalgenderspage-09037f94" */ '@app/pages/greyMuzzleAnimalGenders/greyMuzzleAnimalGenders.js');
		}
	},
	'greymuzzleinquiriespage': {
		chunkName: 'legacy-pages-greymuzzleinquiriespage-1e75d174',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-greymuzzleinquiriespage-1e75d174" */ '@app/pages/greyMuzzleInquiries/greyMuzzleInquiries.js');
		}
	},
	'greymuzzleinquirypage': {
		chunkName: 'legacy-pages-greymuzzleinquirypage-72d79dcc',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-greymuzzleinquirypage-72d79dcc" */ '@app/pages/greyMuzzleInquiry/greyMuzzleInquiry.js');
		}
	},
	'greymuzzlepettypespage': {
		chunkName: 'legacy-pages-greymuzzlepettypespage-bad07b8d',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-greymuzzlepettypespage-bad07b8d" */ '@app/pages/greyMuzzlePetTypes/greyMuzzlePetTypes.js');
		}
	},
	'greymuzzleratingoptionpage': {
		chunkName: 'legacy-pages-greymuzzleratingoptionpage-12b73a9d',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-greymuzzleratingoptionpage-12b73a9d" */ '@app/pages/greyMuzzleRatingOption/greyMuzzleRatingOption.js');
		}
	},
	'greymuzzleresultsrangepage': {
		chunkName: 'legacy-pages-greymuzzleresultsrangepage-cae0be20',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-greymuzzleresultsrangepage-cae0be20" */ '@app/pages/greyMuzzleResultsRange/greyMuzzleResultsRange.js');
		}
	},
	'greymuzzlestatementspage': {
		chunkName: 'legacy-pages-greymuzzlestatementspage-8220711a',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-greymuzzlestatementspage-8220711a" */ '@app/pages/greyMuzzleStatements/greyMuzzleStatements.js');
		}
	},
	'greymuzzlesurveypage': {
		chunkName: 'legacy-pages-greymuzzlesurveypage-83c5b322',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-greymuzzlesurveypage-83c5b322" */ '@app/pages/greyMuzzleSurvey/greyMuzzleSurvey.js');
		}
	},
	'greymuzzlesurveyspage': {
		chunkName: 'legacy-pages-greymuzzlesurveyspage-eda99f81',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-greymuzzlesurveyspage-eda99f81" */ '@app/pages/greyMuzzleSurveys/greyMuzzleSurveys.js');
		}
	},
	'greymuzzlesymptomscategorypage': {
		chunkName: 'legacy-pages-greymuzzlesymptomscategorypage-5e4fbc0d',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-greymuzzlesymptomscategorypage-5e4fbc0d" */ '@app/pages/greyMuzzleSymptomsCategory/greyMuzzleSymptomsCategory.js');
		}
	},
	'greymuzzlesymptomspage': {
		chunkName: 'legacy-pages-greymuzzlesymptomspage-b136359e',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-greymuzzlesymptomspage-b136359e" */ '@app/pages/greyMuzzleSymptoms/greyMuzzleSymptoms.js');
		}
	},
	'greymuzzleuserpage': {
		chunkName: 'legacy-pages-greymuzzleuserpage-0a48719c',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-greymuzzleuserpage-0a48719c" */ '@app/pages/greyMuzzleUser/greyMuzzleUser.js');
		}
	},
	'greymuzzleuserspage': {
		chunkName: 'legacy-pages-greymuzzleuserspage-b0e0753b',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-greymuzzleuserspage-b0e0753b" */ '@app/pages/greyMuzzleUsers/greyMuzzleUsers.js');
		}
	},
	'grouppage': {
		chunkName: 'legacy-pages-grouppage-cc84d1f7',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-grouppage-cc84d1f7" */ '@app/pages/group/group.js');
		}
	},
	'groupspage': {
		chunkName: 'legacy-pages-groupspage-ec7690f9',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-groupspage-ec7690f9" */ '@app/pages/groups/groups.js');
		}
	},
	'holidaydatespage': {
		chunkName: 'legacy-pages-holidaydatespage-f0aaa790',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-holidaydatespage-f0aaa790" */ '@app/pages/holidayDates/holidaydates.js');
		}
	},
	'holidayspage': {
		chunkName: 'legacy-pages-holidayspage-cd676092',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-holidayspage-cd676092" */ '@app/pages/holidays/holidays.js');
		}
	},
	'home': {
		chunkName: 'legacy-pages-home-e83249bd',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-home-e83249bd" */ '@app/pages/home/home.js');
		}
	},
	'hospicecareplandialog': {
		chunkName: 'legacy-pages-hospicecareplandialog-85dbb322',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-hospicecareplandialog-85dbb322" */ '@app/pages/hospiceCarePlanDialog/hospiceCarePlanDialog.js');
		}
	},
	'hospicecareplanselectdialog': {
		chunkName: 'legacy-pages-hospicecareplanselectdialog-dc11e51d',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-hospicecareplanselectdialog-dc11e51d" */ '@app/pages/hospiceCarePlanSelectDialog/hospiceCarePlanSelectDialog.js');
		}
	},
	'hospicemgmtappointmentreportpage': {
		chunkName: 'legacy-pages-hospicemgmtappointmentreportpage-96a72215',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-hospicemgmtappointmentreportpage-96a72215" */ '@app/pages/hospiceMgmtAppointmentReport/hospiceMgmtAppointmentReport.js');
		}
	},
	'hospicepetreportpage': {
		chunkName: 'legacy-pages-hospicepetreportpage-fd8482f8',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-hospicepetreportpage-fd8482f8" */ '@app/pages/hospicePetReport/hospicePetReport.js');
		}
	},
	'hospicerefillremindersreportpage': {
		chunkName: 'legacy-pages-hospicerefillremindersreportpage-604b67b2',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-hospicerefillremindersreportpage-604b67b2" */ '@app/pages/hospiceRefillRemindersReport/hospiceRefillRemindersReport.js');
		}
	},
	'imagesdialog': {
		chunkName: 'legacy-pages-imagesdialog-44c30d65',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-imagesdialog-44c30d65" */ '@common/Scripts/pages/imagesDialog/imagesDialog.js');
		}
	},
	'includedincostspage': {
		chunkName: 'legacy-pages-includedincostspage-3154bdf4',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-includedincostspage-3154bdf4" */ '@app/pages/includedInCosts/includedInCosts.js');
		}
	},
	'insightspage': {
		chunkName: 'legacy-pages-insightspage-832e420b',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-insightspage-832e420b" */ '@app/pages/insights/insights.js');
		}
	},
	'intacctdialog': {
		chunkName: 'legacy-pages-intacctdialog-51fadcb9',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-intacctdialog-51fadcb9" */ '@app/pages/intacctDialog/intacctdialog.js');
		}
	},
	'intacctinteractivepage': {
		chunkName: 'legacy-pages-intacctinteractivepage-7e43a615',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-intacctinteractivepage-7e43a615" */ '@app/pages/intacctinteractive/intacctinteractive.js');
		}
	},
	'intacctuserspage': {
		chunkName: 'legacy-pages-intacctuserspage-3672fb74',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-intacctuserspage-3672fb74" */ '@app/pages/intacctusers/intacctusers.js');
		}
	},
	'invoicecreationjobpage': {
		chunkName: 'legacy-pages-invoicecreationjobpage-ad54668f',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-invoicecreationjobpage-ad54668f" */ '@app/pages/invoiceCreationJobs/invoiceCreationJob.js');
		}
	},
	'jobtitlespage': {
		chunkName: 'legacy-pages-jobtitlespage-7aa3824a',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-jobtitlespage-7aa3824a" */ '@app/pages/jobTitles/jobTitles.js');
		}
	},
	'languagespage': {
		chunkName: 'legacy-pages-languagespage-e70b03a0',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-languagespage-e70b03a0" */ '@app/pages/languages/languages.js');
		}
	},
	'lastuseractivityreportpage': {
		chunkName: 'legacy-pages-lastuseractivityreportpage-674db0d9',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-lastuseractivityreportpage-674db0d9" */ '@app/pages/lastUserActivityReport/lastUserActivityReport.js');
		}
	},
	'logindialog': {
		chunkName: 'legacy-pages-logindialog-f23af6b3',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-logindialog-f23af6b3" */ '@common/Scripts/pages/loginDialog/loginDialog.js');
		}
	},
	'loginpage': {
		chunkName: 'legacy-pages-loginpage-eee8cef5',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-loginpage-eee8cef5" */ '@app/pages/login/login.js');
		}
	},
	'lolattentionmessagespage': {
		chunkName: 'legacy-pages-lolattentionmessagespage-2aec6349',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-lolattentionmessagespage-2aec6349" */ '@app/pages/attentionMessages/lolAttentionMessages.js');
		}
	},
	'loventitiespage': {
		chunkName: 'legacy-pages-loventitiespage-3bf3f15e',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-loventitiespage-3bf3f15e" */ '@app/pages/lovEntities/lovEntities.js');
		}
	},
	'mapdialog': {
		chunkName: 'legacy-pages-mapdialog-3fe521a8',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-mapdialog-3fe521a8" */ '@app/pages/mapDialog/mapDialog.js');
		}
	},
	'markedfordeletionpage': {
		chunkName: 'legacy-pages-markedfordeletionpage-868ef1da',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-markedfordeletionpage-868ef1da" */ '@app/pages/markedForDeletion/markedForDeletion.js');
		}
	},
	'marketinginsightspage': {
		chunkName: 'legacy-pages-marketinginsightspage-6f7bcade',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-marketinginsightspage-6f7bcade" */ '@app/pages/marketingInsights/marketingInsights.js');
		}
	},
	'memorialcandlepage': {
		chunkName: 'legacy-pages-memorialcandlepage-5dcd1a65',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-memorialcandlepage-5dcd1a65" */ '@app/pages/memorialCandle/memorialCandle.js');
		}
	},
	'minorservicepage': {
		chunkName: 'legacy-pages-minorservicepage-096ad4b3',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-minorservicepage-096ad4b3" */ '@app/pages/minorService/minorService.js');
		}
	},
	'mobilevetdashboard': {
		chunkName: 'legacy-pages-mobilevetdashboard-0aedb95e',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-mobilevetdashboard-0aedb95e" */ '@app/pages/mobileVetDashboard/mobileVetDashboard.js');
		}
	},
	'moneytoreceivepage': {
		chunkName: 'legacy-pages-moneytoreceivepage-5dacf486',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-moneytoreceivepage-5dacf486" */ '@app/pages/moneyToReceive/moneyToReceive.js');
		}
	},
	'myimpactpage': {
		chunkName: 'legacy-pages-myimpactpage-018bfb5a',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-myimpactpage-018bfb5a" */ '@app/pages/myImpact/myImpact.js');
		}
	},
	'mytodopage': {
		chunkName: 'legacy-pages-mytodopage-4a99df95',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-mytodopage-4a99df95" */ '@app/pages/mytodo/mytodo.js');
		}
	},
	'newvetactionspage': {
		chunkName: 'legacy-pages-newvetactionspage-44d79202',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-newvetactionspage-44d79202" */ '@app/pages/newVetActions/newVetActions.js');
		}
	},
	'notesdialog': {
		chunkName: 'legacy-pages-notesdialog-1f0a3f40',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-notesdialog-1f0a3f40" */ '@app/pages/notesDialog/notesDialog.js');
		}
	},
	'notificationspage': {
		chunkName: 'legacy-pages-notificationspage-318a1165',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-notificationspage-318a1165" */ '@app/pages/notifications/notifications.js');
		}
	},
	'odometerreportpage': {
		chunkName: 'legacy-pages-odometerreportpage-78c30ed1',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-odometerreportpage-78c30ed1" */ '@app/pages/odometerReport/odometerReport.js');
		}
	},
	'offboardingactionpage': {
		chunkName: 'legacy-pages-offboardingactionpage-60760f9c',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-offboardingactionpage-60760f9c" */ '@app/pages/offBoardingVetActions/offBoardingVetActions.js');
		}
	},
	'onboardingvetspage': {
		chunkName: 'legacy-pages-onboardingvetspage-f1cb7711',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-onboardingvetspage-f1cb7711" */ '@app/pages/onboardingVets/onboardingVets.js');
		}
	},
	'onlinebookingemailtickerspage': {
		chunkName: 'legacy-pages-onlinebookingemailtickerspage-d12677dc',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-onlinebookingemailtickerspage-d12677dc" */ '@app/pages/onlineBookingEmailTickers/onlineBookingEmailTickers.js');
		}
	},
	'onlinebookingentriespage': {
		chunkName: 'legacy-pages-onlinebookingentriespage-30f0d93d',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-onlinebookingentriespage-30f0d93d" */ '@app/pages/onlineBookingEntries/onlineBookingEntries.js');
		}
	},
	'ownerdispositionspage': {
		chunkName: 'legacy-pages-ownerdispositionspage-6ed2c261',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-ownerdispositionspage-6ed2c261" */ '@app/pages/ownerDispositions/ownerDispositions.js');
		}
	},
	'passworddialog': {
		chunkName: 'legacy-pages-passworddialog-314ec0ed',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-passworddialog-314ec0ed" */ '@common/Scripts/pages/passwordDialog/passwordDialog.js');
		}
	},
	'paymentaccountspage': {
		chunkName: 'legacy-pages-paymentaccountspage-c85aaaa5',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-paymentaccountspage-c85aaaa5" */ '@app/pages/paymentAccounts/paymentAccounts.js');
		}
	},
	'paymentreportpage': {
		chunkName: 'legacy-pages-paymentreportpage-053d53b5',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-paymentreportpage-053d53b5" */ '@app/pages/paymentReport/paymentReport.js');
		}
	},
	'paymenttypespage': {
		chunkName: 'legacy-pages-paymenttypespage-11c6998c',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-paymenttypespage-11c6998c" */ '@app/pages/paymentTypes/paymentTypes.js');
		}
	},
	'paypaltoprocesspage': {
		chunkName: 'legacy-pages-paypaltoprocesspage-97ed09df',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-paypaltoprocesspage-97ed09df" */ '@app/pages/paypalToProcess/paypalToProcess.js');
		}
	},
	'petattitudespage': {
		chunkName: 'legacy-pages-petattitudespage-78e1a54d',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-petattitudespage-78e1a54d" */ '@app/pages/petAttitudes/petAttitudes.js');
		}
	},
	'petmemorialpage': {
		chunkName: 'legacy-pages-petmemorialpage-e0dc2463',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-petmemorialpage-e0dc2463" */ '@app/pages/petMemorial/petMemorial.js');
		}
	},
	'petmemorialspage': {
		chunkName: 'legacy-pages-petmemorialspage-98b36676',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-petmemorialspage-98b36676" */ '@app/pages/petMemorials/petMemorials.js');
		}
	},
	'petmemorialspopuppage': {
		chunkName: 'legacy-pages-petmemorialspopuppage-244a8a62',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-petmemorialspopuppage-244a8a62" */ '@app/pages/petMemorialsPopup/petMemorialsPopup.js');
		}
	},
	'petonlineattitudespage': {
		chunkName: 'legacy-pages-petonlineattitudespage-9ac10a82',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-petonlineattitudespage-9ac10a82" */ '@app/pages/petOnlineAttitudes/petOnlineAttitudes.js');
		}
	},
	'petownersourcespage': {
		chunkName: 'legacy-pages-petownersourcespage-df2a3cad',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-petownersourcespage-df2a3cad" */ '@app/pages/petOwnerSources/petOwnerSources.js');
		}
	},
	'petpage': {
		chunkName: 'legacy-pages-petpage-280c3f69',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-petpage-280c3f69" */ '@app/pages/pet/pet.js');
		}
	},
	'petselectpopup': {
		chunkName: 'legacy-pages-petselectpopup-1e49a6fb',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-petselectpopup-1e49a6fb" */ '@app/pages/petSelectPopUp/petSelectPopUp.js');
		}
	},
	'petsizespage': {
		chunkName: 'legacy-pages-petsizespage-7b601466',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-petsizespage-7b601466" */ '@app/pages/petSizes/petSizes.js');
		}
	},
	'petspage': {
		chunkName: 'legacy-pages-petspage-4adbfc39',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-petspage-4adbfc39" */ '@app/pages/pets/pets.js');
		}
	},
	'pettypeflagspage': {
		chunkName: 'legacy-pages-pettypeflagspage-d89b4e1a',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-pettypeflagspage-d89b4e1a" */ '@app/pages/petTypeFlags/petTypeFlags.js');
		}
	},
	'pettypespage': {
		chunkName: 'legacy-pages-pettypespage-cdbe8aa7',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-pettypespage-cdbe8aa7" */ '@app/pages/petTypes/petTypes.js');
		}
	},
	'pricingpage': {
		chunkName: 'legacy-pages-pricingpage-e0828a0b',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-pricingpage-e0828a0b" */ '@app/pages/pricing/pricing.js');
		}
	},
	'promptspage': {
		chunkName: 'legacy-pages-promptspage-390fa8fc',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-promptspage-390fa8fc" */ '@app/pages/prompts/prompts.js');
		}
	},
	'rdvmfilespage': {
		chunkName: 'legacy-pages-rdvmfilespage-3d387075',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-rdvmfilespage-3d387075" */ '@app/pages/rdvmFiles/rdvmFiles.js');
		}
	},
	'rdvmpage': {
		chunkName: 'legacy-pages-rdvmpage-a03a2dba',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-rdvmpage-a03a2dba" */ '@app/pages/rdvm/rdvm.js');
		}
	},
	'rdvmsdialog': {
		chunkName: 'legacy-pages-rdvmsdialog-8a6c5b2a',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-rdvmsdialog-8a6c5b2a" */ '@app/pages/rdvmsDialog/rdvmsDialog.js');
		}
	},
	'rdvmspage': {
		chunkName: 'legacy-pages-rdvmspage-93df9614',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-rdvmspage-93df9614" */ '@app/pages/rdvms/rdvms.js');
		}
	},
	'reconciliationpage': {
		chunkName: 'legacy-pages-reconciliationpage-942fc12d',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-reconciliationpage-942fc12d" */ '@app/pages/reconciliation/reconciliation.js');
		}
	},
	'reconnectiondialog': {
		chunkName: 'legacy-pages-reconnectiondialog-754f3d5d',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-reconnectiondialog-754f3d5d" */ '@app/pages/reconnectionDialog/reconnectionDialog.js');
		}
	},
	'recoverpage': {
		chunkName: 'legacy-pages-recoverpage-87dc1131',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-recoverpage-87dc1131" */ '@app/pages/recover/recover.js');
		}
	},
	'recruitmentlocationspage': {
		chunkName: 'legacy-pages-recruitmentlocationspage-c868fbbc',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-recruitmentlocationspage-c868fbbc" */ '@app/pages/recruitmentLocations/recruitmentLocations.js');
		}
	},
	'recruitmentpage': {
		chunkName: 'legacy-pages-recruitmentpage-81eed7c4',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-recruitmentpage-81eed7c4" */ '@app/pages/recruitment/recruitment.js');
		}
	},
	'referredappointmentspage': {
		chunkName: 'legacy-pages-referredappointmentspage-4585441f',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-referredappointmentspage-4585441f" */ '@app/pages/referredAppointments/referredAppointments.js');
		}
	},
	'refundreasonspage': {
		chunkName: 'legacy-pages-refundreasonspage-fbda8cee',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-refundreasonspage-fbda8cee" */ '@app/pages/refundreasons/refundreasons.js');
		}
	},
	'reportspage': {
		chunkName: 'legacy-pages-reportspage-cd9b6f6f',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-reportspage-cd9b6f6f" */ '@app/pages/reports/reports.js');
		}
	},
	'requestedzipcodereportpage': {
		chunkName: 'legacy-pages-requestedzipcodereportpage-ff28859e',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-requestedzipcodereportpage-ff28859e" */ '@app/pages/requestedZipCodeReport/requestedZipCodeReport.js');
		}
	},
	'resourcepage': {
		chunkName: 'legacy-pages-resourcepage-a4c5906e',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-resourcepage-a4c5906e" */ '@app/pages/resource/resource.js');
		}
	},
	'resourcespage': {
		chunkName: 'legacy-pages-resourcespage-391c9ff4',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-resourcespage-391c9ff4" */ '@app/pages/resources/resources.js');
		}
	},
	'resourcesregistrationspage': {
		chunkName: 'legacy-pages-resourcesregistrationspage-bcf3849d',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-resourcesregistrationspage-bcf3849d" */ '@app/pages/resourcesRegistrations/resourcesRegistrations.js');
		}
	},
	'resourcetopicpage': {
		chunkName: 'legacy-pages-resourcetopicpage-93ea8418',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-resourcetopicpage-93ea8418" */ '@app/pages/resourceTopic/resourceTopic.js');
		}
	},
	'resourcetopicspage': {
		chunkName: 'legacy-pages-resourcetopicspage-17c59c4a',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-resourcetopicspage-17c59c4a" */ '@app/pages/resourceTopics/resourceTopics.js');
		}
	},
	'returnlocationpage': {
		chunkName: 'legacy-pages-returnlocationpage-a8004451',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-returnlocationpage-a8004451" */ '@app/pages/returnLocation/returnLocation.js');
		}
	},
	'reuploadtransactionspopuppage': {
		chunkName: 'legacy-pages-reuploadtransactionspopuppage-c1abf7f2',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-reuploadtransactionspopuppage-c1abf7f2" */ '@app/pages/reuploadTransactionsPopup/reuploadTransactionsPopup.js');
		}
	},
	'rotatedialog': {
		chunkName: 'legacy-pages-rotatedialog-750c3264',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-rotatedialog-750c3264" */ '@app/pages/rotateDialogs/rotateDialog.js');
		}
	},
	'sessionspage': {
		chunkName: 'legacy-pages-sessionspage-09e69e65',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-sessionspage-09e69e65" */ '@app/pages/sessions/sessions.js');
		}
	},
	'signindialog': {
		chunkName: 'legacy-pages-signindialog-2d463e87',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-signindialog-2d463e87" */ '@app/pages/signin/signin.js');
		}
	},
	'smscancellationreportpage': {
		chunkName: 'legacy-pages-smscancellationreportpage-6a2b4092',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-smscancellationreportpage-6a2b4092" */ '@app/pages/smsCancellationReport/smsCancellationReport.js');
		}
	},
	'smsmessagingcreationjobpage': {
		chunkName: 'legacy-pages-smsmessagingcreationjobpage-bb5f33b5',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-smsmessagingcreationjobpage-bb5f33b5" */ '@app/pages/smsMessagingCreationJob/smsMessagingCreationJob.js');
		}
	},
	'smsmessagingpage': {
		chunkName: 'legacy-pages-smsmessagingpage-8148b4c2',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-smsmessagingpage-8148b4c2" */ '@app/pages/smsMessaging/smsMessaging.js');
		}
	},
	'smsmessagingreportpage': {
		chunkName: 'legacy-pages-smsmessagingreportpage-09b4c83d',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-smsmessagingreportpage-09b4c83d" */ '@app/pages/smsMessagingReport/smsMessagingReport.js');
		}
	},
	'statespage': {
		chunkName: 'legacy-pages-statespage-e034b9ab',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-statespage-e034b9ab" */ '@app/pages/states/states.js');
		}
	},
	'statetaxespage': {
		chunkName: 'legacy-pages-statetaxespage-1172583c',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-statetaxespage-1172583c" */ '@app/pages/stateTaxes/stateTaxes.js');
		}
	},
	'statetaxpage': {
		chunkName: 'legacy-pages-statetaxpage-f342d5ce',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-statetaxpage-f342d5ce" */ '@app/pages/stateTax/stateTax.js');
		}
	},
	'suggestivebookingdetailreportpage': {
		chunkName: 'legacy-pages-suggestivebookingdetailreportpage-cf24906e',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-suggestivebookingdetailreportpage-cf24906e" */ '@app/pages/suggestiveBookingDetailReport/suggestiveBookingDetailReport.js');
		}
	},
	'suggestivebookingsummaryreportpage': {
		chunkName: 'legacy-pages-suggestivebookingsummaryreportpage-3fe24de5',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-suggestivebookingsummaryreportpage-3fe24de5" */ '@app/pages/suggestiveBookingSummaryReport/suggestiveBookingSummaryReport.js');
		}
	},
	'supportcentersnapshotpage': {
		chunkName: 'legacy-pages-supportcentersnapshotpage-a1041202',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-supportcentersnapshotpage-a1041202" */ '@app/pages/supportCenterSnapshot/supportCenterSnapshot.js');
		}
	},
	'supportcenterstodopage': {
		chunkName: 'legacy-pages-supportcenterstodopage-ee34bfc8',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-supportcenterstodopage-ee34bfc8" */ '@app/pages/supportCentersToDo/supportCentersToDo.js');
		}
	},
	'supportcentertodopopuppage': {
		chunkName: 'legacy-pages-supportcentertodopopuppage-385f164f',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-supportcentertodopopuppage-385f164f" */ '@app/pages/supportCentersToDoPopup/supportCenterToDoPopup.js');
		}
	},
	'symptomcategorylistpage': {
		chunkName: 'legacy-pages-symptomcategorylistpage-a406243e',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-symptomcategorylistpage-a406243e" */ '@app/pages/symptomCategoryList/symptomCategoryList.js');
		}
	},
	'symptomcategorypage': {
		chunkName: 'legacy-pages-symptomcategorypage-6a53eaa6',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-symptomcategorypage-6a53eaa6" */ '@app/pages/symptomCategory/symptomCategory.js');
		}
	},
	'symptomsstatisticreportpage': {
		chunkName: 'legacy-pages-symptomsstatisticreportpage-20d2611a',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-symptomsstatisticreportpage-20d2611a" */ '@app/pages/symptomsStatisticReport/symptomsStatisticReport.js');
		}
	},
	'testimonialpage': {
		chunkName: 'legacy-pages-testimonialpage-e18c647c',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-testimonialpage-e18c647c" */ '@app/pages/testimonial/testimonial.js');
		}
	},
	'testimonialreportpage': {
		chunkName: 'legacy-pages-testimonialreportpage-fb7b224b',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-testimonialreportpage-fb7b224b" */ '@app/pages/testimonialReport/testimonialReport.js');
		}
	},
	'testimonialspage': {
		chunkName: 'legacy-pages-testimonialspage-f25cafed',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-testimonialspage-f25cafed" */ '@app/pages/testimonials/testimonials.js');
		}
	},
	'textmessagetemplatespage': {
		chunkName: 'legacy-pages-textmessagetemplatespage-21a11bd9',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-textmessagetemplatespage-21a11bd9" */ '@app/pages/emailTemplates/textMessageTemplates.js');
		}
	},
	'typeofvetvetactionpage': {
		chunkName: 'legacy-pages-typeofvetvetactionpage-66cd1d2d',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-typeofvetvetactionpage-66cd1d2d" */ '@app/pages/typeOfVetVetAction/typeOfVetVetAction.js');
		}
	},
	'typesofvetpage': {
		chunkName: 'legacy-pages-typesofvetpage-a302a594',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-typesofvetpage-a302a594" */ '@app/pages/typesOfVet/typesOfVet.js');
		}
	},
	'urndescriptionspage': {
		chunkName: 'legacy-pages-urndescriptionspage-5af04018',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-urndescriptionspage-5af04018" */ '@app/pages/urnDescriptions/urnDescriptions.js');
		}
	},
	'useragreementdialog': {
		chunkName: 'legacy-pages-useragreementdialog-34a33d46',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-useragreementdialog-34a33d46" */ '@app/pages/userAgreement/userAgreement.js');
		}
	},
	'useragreementspage': {
		chunkName: 'legacy-pages-useragreementspage-d0d4e39e',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-useragreementspage-d0d4e39e" */ '@app/pages/userAgreements/userAgreements.js');
		}
	},
	'userdialog': {
		chunkName: 'legacy-pages-userdialog-8e05a2ce',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-userdialog-8e05a2ce" */ '@app/pages/userDialog/userDialog.js');
		}
	},
	'userdruglistpage': {
		chunkName: 'legacy-pages-userdruglistpage-2269ff03',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-userdruglistpage-2269ff03" */ '@app/pages/userDrugList/userDrugList.js');
		}
	},
	'userpage': {
		chunkName: 'legacy-pages-userpage-ea81d010',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-userpage-ea81d010" */ '@app/pages/user/user.js');
		}
	},
	'userspage': {
		chunkName: 'legacy-pages-userspage-74256d9f',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-userspage-74256d9f" */ '@app/pages/users/users.js');
		}
	},
	'userweightsettingspage': {
		chunkName: 'legacy-pages-userweightsettingspage-ca80771b',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-userweightsettingspage-ca80771b" */ '@app/pages/userWeightSettings/userWeightSettings.js');
		}
	},
	'userzippage': {
		chunkName: 'legacy-pages-userzippage-0c56643f',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-userzippage-0c56643f" */ '@app/pages/userZip/userZip.js');
		}
	},
	'vacationdatelogpage': {
		chunkName: 'legacy-pages-vacationdatelogpage-93b8afa7',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-vacationdatelogpage-93b8afa7" */ '@app/pages/vacationDateLog/vacationDateLog.js');
		}
	},
	'vetactionsoffboardingpage': {
		chunkName: 'legacy-pages-vetactionsoffboardingpage-c7cddc60',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-vetactionsoffboardingpage-c7cddc60" */ '@app/pages/vetActions/vetActionsOffBoarding.js');
		}
	},
	'vetactionsonboardingpage': {
		chunkName: 'legacy-pages-vetactionsonboardingpage-a81419cf',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-vetactionsonboardingpage-a81419cf" */ '@app/pages/vetActions/vetActionsOnBoarding.js');
		}
	},
	'vetactionspage': {
		chunkName: 'legacy-pages-vetactionspage-ff3b8455',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-vetactionspage-ff3b8455" */ '@app/pages/vetActions/vetActions.js');
		}
	},
	'vetactionstatuslogpage': {
		chunkName: 'legacy-pages-vetactionstatuslogpage-6c0b9c96',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-vetactionstatuslogpage-6c0b9c96" */ '@app/pages/vetActionStatusLog/vetActionStatusLog.js');
		}
	},
	'vetactionstatuspage': {
		chunkName: 'legacy-pages-vetactionstatuspage-88e215ea',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-vetactionstatuspage-88e215ea" */ '@app/pages/vetActionStatus/vetActionStatus.js');
		}
	},
	'vetconsentformreportpage': {
		chunkName: 'legacy-pages-vetconsentformreportpage-c10fc4c4',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-vetconsentformreportpage-c10fc4c4" */ '@app/pages/vetConsentFormReport/vetConsentFormReport.js');
		}
	},
	'veterinaryimpactpage': {
		chunkName: 'legacy-pages-veterinaryimpactpage-c9375ae6',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-veterinaryimpactpage-c9375ae6" */ '@app/pages/veterinaryImpact/veterinaryImpact.js');
		}
	},
	'veterinaryinsightspage': {
		chunkName: 'legacy-pages-veterinaryinsightspage-8eb21998',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-veterinaryinsightspage-8eb21998" */ '@app/pages/veterinaryInsights/veterinaryInsights.js');
		}
	},
	'veterinaryschoolspage': {
		chunkName: 'legacy-pages-veterinaryschoolspage-362bbccb',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-veterinaryschoolspage-362bbccb" */ '@app/pages/veterinarySchools/veterinarySchools.js');
		}
	},
	'vetmaturityreportpage': {
		chunkName: 'legacy-pages-vetmaturityreportpage-592d33bc',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-vetmaturityreportpage-592d33bc" */ '@app/pages/vetMaturityReport/vetMaturityReport.js');
		}
	},
	'vetpaymentreportpage': {
		chunkName: 'legacy-pages-vetpaymentreportpage-e17bb2dd',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-vetpaymentreportpage-e17bb2dd" */ '@app/pages/vetpaymentReport/vetpaymentReport.js');
		}
	},
	'vetregistrationpage': {
		chunkName: 'legacy-pages-vetregistrationpage-8e33c55d',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-vetregistrationpage-8e33c55d" */ '@app/pages/vetRegistration/vetRegistration.js');
		}
	},
	'vetregistrationspage': {
		chunkName: 'legacy-pages-vetregistrationspage-4041eb95',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-vetregistrationspage-4041eb95" */ '@app/pages/vetRegistrations/vetRegistrations.js');
		}
	},
	'viewingspage': {
		chunkName: 'legacy-pages-viewingspage-20a7457d',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-viewingspage-20a7457d" */ '@app/pages/viewings/viewings.js');
		}
	},
	'waitingreasonspage': {
		chunkName: 'legacy-pages-waitingreasonspage-84c2876b',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-waitingreasonspage-84c2876b" */ '@app/pages/waitingReasons/waitingReasons.js');
		}
	},
	'webformspage': {
		chunkName: 'legacy-pages-webformspage-b5e82c6d',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-webformspage-b5e82c6d" */ '@app/pages/webforms/webforms.js');
		}
	},
	'websitecontentlistpage': {
		chunkName: 'legacy-pages-websitecontentlistpage-ac7e9f2f',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-websitecontentlistpage-ac7e9f2f" */ '@app/pages/websiteContentList/websiteContentList.js');
		}
	},
	'websitecontentpage': {
		chunkName: 'legacy-pages-websitecontentpage-b5f4b0fa',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-websitecontentpage-b5f4b0fa" */ '@app/pages/websiteContent/websiteContent.js');
		}
	},
	'whathappenedpage': {
		chunkName: 'legacy-pages-whathappenedpage-d089f5e9',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-whathappenedpage-d089f5e9" */ '@app/pages/whatHappened/whatHappened.js');
		}
	},
	'workswithpublicpage': {
		chunkName: 'legacy-pages-workswithpublicpage-52aa7270',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-workswithpublicpage-52aa7270" */ '@app/pages/worksWithPublic/worksWithPublic.js');
		}
	},
	'zippage': {
		chunkName: 'legacy-pages-zippage-ac8c47dc',
		load: function () {
			return import(/* webpackChunkName: "legacy-pages-zippage-ac8c47dc" */ '@app/pages/zipList/zip.js');
		}
	}
};
const cache = Object.create(null);

function normalizeName(name) {
	return String(name || '').trim().toLowerCase();
}

api.has = function (name) {
	return Object.prototype.hasOwnProperty.call(modules, normalizeName(name));
};

api.chunkName = function (name) {
	const module = modules[normalizeName(name)];
	return module ? module.chunkName : null;
};

api.load = function (name) {
	const normalizedName = normalizeName(name);
	const module = modules[normalizedName];
	if (!module) {
		return Promise.reject(new Error('Unknown legacy page module: ' + normalizedName));
	}
	if (!cache[normalizedName]) {
		cache[normalizedName] = module.load().catch(function (error) {
			delete cache[normalizedName];
			throw error;
		});
	}
	return cache[normalizedName];
};

api.loadAll = function (names) {
	return Promise.all((names || []).map(api.load));
};

export default api;
